import React from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import { toggleTheme, useTheme } from '../utils/theme';

// Sun/moon button that flips between light and dark mode. Styles live in theme.css.
export default function ThemeToggle({ compact = false, className = '' }) {
  const [theme] = useTheme();
  const label = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <button
      type="button"
      className={`nb-theme-toggle ${compact ? 'is-compact' : ''} ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      <FiSun className="nb-sun" aria-hidden="true" />
      <FiMoon className="nb-moon" aria-hidden="true" />
    </button>
  );
}
